import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, formDataCommonFunctionPut, serviceCall } from '../../serviceCall'

const updateSubscriptionById = (data, callback, errorCallBack, params) => {

    return async (dispatch) => {

        formDataCommonFunctionPut(data, apiConstants.PAYMENT_GATEWAY.UPDATE_SUBSCRIPTION_BY_ID)
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
}

export default updateSubscriptionById;